import { render, staticRenderFns } from "./s1-3.vue?vue&type=template&id=159eb156&scoped=true&"
import script from "./s1-3.vue?vue&type=script&lang=js&"
export * from "./s1-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159eb156",
  null
  
)

export default component.exports